/**
 * 双方向 sticky（下スクロールで下端追従・上スクロールで上端追従）の `top` を
 * 算出する純粋関数群。DOM に依存しないため単体テストで担保する。
 *
 * 座標系の前提: sticky 要素（nav）は自身に縦 padding を持ち、その padding は
 * `offsetHeight` に含まれる。したがって border-box の上端がスクロールポート
 * 上端に一致する `top = 0` の時点で中身のカードは padding 分だけ下に見え、
 * border-box の下端が一致する `top = scrollportHeight - navHeight` の時点で
 * カードは padding 分だけ上に見える。余白の正は Tailwind の `py-*` のみで、
 * ここに設計値（32px 等）を持ち込まない。
 */

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/**
 * `top` の下限（下端固定値）を求める。
 *
 * - nav がスクロールポートに収まる場合は `0`（＝常に上端固定）
 * - nav がスクロールポートより長い場合は負値（＝はみ出した分だけ上へずらせる）
 */
export function calcMinTop({
  scrollportHeight,
  navHeight
}: {
  scrollportHeight: number;
  navHeight: number;
}): number {
  return Math.min(0, scrollportHeight - navHeight);
}

/**
 * スクロール差分 `delta`（下方向を正）から次の `top` を求める。
 *
 * 下スクロール（`delta > 0`）で `top` は減り `minTop` で止まり、
 * 上スクロール（`delta < 0`）で `top` は増え `0` で止まる。
 */
export function calcNextTop({
  prevTop,
  delta,
  minTop
}: {
  prevTop: number;
  delta: number;
  minTop: number;
}): number {
  return clamp(prevTop - delta, minTop, 0);
}